export const S3 = 'S3';
export const IMGIX = 'imgix';

export const vendorUrls = {
  S3: 'https://th3insid3.s3.amazonaws.com',
  imgix: 'https://theinside.imgix.net'
}

export default function getImageUrl(path, vendor = IMGIX) {
  if (vendor in vendorUrls) {
    return `${vendorUrls[vendor]}/${path}`;
  }

  return `${vendorUrls.S3}/${path}`;
}
